import adultIcon from "components/icons/18+.svg";
import classes from "./SignUpIncorrectBirthStep.module.scss";

interface IProps {
  back: () => void;
}

const SignUpIncorrectBirthStep = (props: IProps) => {
  const { back } = props;

  return (
    <div className={classes.incorrectBirth}>
      <div className={classes.warning}>
        <img src={adultIcon} width="140" height="140" alt="" />
        <span>
          You must be at least 18 years old to join RedGIFs
        </span>
      </div>
      <div className={classes.back}>
        <div>
          Entered data incorrectly?
        </div>
        <button type="button" onClick={back}>Enter again</button>
      </div>
    </div>
  );
};

export default SignUpIncorrectBirthStep;
